import MuiBox from '@mui/material/Box';

import { styled } from 'helpers';

import { Props } from './types';

// Bit of a hack to retain 'component' prop.
// https://github.com/mui-org/material-ui/issues/15695#issuecomment-498242520
export const Box = styled(MuiBox)<Props>`` as typeof MuiBox;
// @ts-ignore
Box.displayName = 'Box';

export default Box;
